import axios from 'services/axios';

export const readAlertPresets = async () => {
  return await axios.get('/notifications/alert-presets/admin-panel');
};

export const updateAlertPreset = async (slot, params) => {
  return await axios.put(`/notifications/alert-presets/${slot}`, params);
};

export const resetAlertPreset = async (slot) => {
  return await axios.delete(`/notifications/alert-presets/${slot}`);
};
